import { render } from "./auth-register.vue?vue&type=template&id=dc437eae"
import script from "./auth-register.vue?vue&type=script&lang=js"
export * from "./auth-register.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__